// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"Calendar_maxWidth__MGZXn"};